import React from "react";

export const AI_MODEL_OPTIONS = [
  { k: "claude", label: "Claude Sonnet 4.6" },
  { k: "chatgpt", label: "ChatGPT (GPT-5.4)" },
];

// Compact model switcher shared across every AI surface (per-request choice).
export default function ModelPicker({ value, onChange, testid = "ai-model-picker", className = "" }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testid}
      className={className}
    >
      {AI_MODEL_OPTIONS.map((m) => (
        <option key={m.k} value={m.k}>{m.label}</option>
      ))}
    </select>
  );
}
